import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface ProductVideoUrlStyles {
    wrapper?: InjectableCss;
    videoLabel: TypographyPresentationProps;
    videoLink?: LinkPresentationProps;
}

export const styles: ProductVideoUrlStyles = {
    wrapper: {
        css: css`
            padding-bottom: 15px;
        `,
    },
    videoLabel: {
        weight: "bold"
    }
}

const ProductVideoUrl: React.FC<HasProduct> = ({ product }) => {
    if (!product) {
        return null;
    }

    return (
        <>
            {product.properties.videoUrl && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.videoLabel}>{translate("Video")}:&nbsp;</Typography>
                    <Link
                        href={product.properties.videoUrl}
                        target="_new"
                        {...styles.videoLink}
                    >
                        <Typography>{product.properties.videoUrl}</Typography>
                    </Link>

                </StyledWrapper>              
            )}
        </>
    );
};

const productVideoUrlModule: WidgetModule = {
    component: withProduct(ProductVideoUrl),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default productVideoUrlModule;